import React, { useRef } from 'react';
import "./MailingListSignup.css"
import emailjs from '@emailjs/browser';

export default function MailingListSignup() {
  const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
      emailjs.sendForm(process.env.REACT_APP_SERVICE_ID,process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_PUBLIC_KEY)
        .then((result) => {
          console.log(result.text);
          // navigate('/'); ///OR TY Message?
          window.scrollTo(0, 0)
        }, (error) => {
            console.log(error.text);
        });
    };


  return (
    <div className='mailing-list-signup__container'>
    <form className='form__container' ref={form} onSubmit={sendEmail}>
    <h3>Mailing List Signup</h3>
      <label className='form__label'>Name</label>
      <input className='form__input' type="text" name="to_name" required />
      <label className='form__label'>Email</label>
      <input className='form__input' type="email" name="user_email" required />
      <input className='form__button'  type="submit" value="Submit" />
          
        </form>
    </div>
  )
}
